module.exports = __webpack_public_path__ + "static/simona2-51b36fde368426c55edab824b9be5abd.jpg";